/** Configuration to dynamically generate the form, with the necessary information to indicate which is the next list of data to request */
export const PTA_FORM_SETTINGS = {
  make: {
    type: 'select',
    next: 'year',
    placeholder: 'Selecciona una marca',
    label: 'Marca',
    errors: {
      empty: {
        text: 'Campo obligatorio'
      }
    }
  },
  year: {
    type: 'select',
    next: 'fuel',
    placeholder: 'Selecciona un año',
    label: 'Año',
    errors: {
      empty: {
        text: 'Campo obligatorio'
      }
    }
  },
  fuel: {
    type: 'select',
    next: 'model',
    placeholder: 'Selecciona un tipo de gasolina',
    label: 'Combustible',
    errors: {
      empty: {
        text: 'Campo obligatorio'
      }
    }
  },
  model: {
    type: 'select',
    next: 'body',
    placeholder: 'Selecciona un modelo',
    label: 'Modelo',
    errors: {
      empty: {
        text: 'Campo obligatorio'
      }
    }
  },
  body: {
    type: 'select',
    next: 'version',
    placeholder: 'Selecciona una carrocería',
    label: 'Carrocería',
    errors: {
      empty: {
        text: 'Campo obligatorio'
      }
    }
  },
  version: {
    type: 'select',
    next: 'gearbox',
    placeholder: 'Selecciona una versión',
    label: 'Versión',
    errors: {
      empty: {
        text: 'Campo obligatorio'
      }
    }
  },
  gearbox: {
    type: 'select',
    next: 'color',
    placeholder: 'Selecciona una versión',
    label: 'Tipo de cambio',
    errors: {
      empty: {
        text: 'Campo obligatorio'
      }
    }
  },
  km: {
    persists: true,
    type: 'input',
    inputType: 'number',
    placeholder: 'Introduce los kilómetros',
    label: 'Kilómetros',
    errors: {
      empty: {
        text: 'Campo obligatorio'
      }
    }
  },
  color: {
    type: 'select',
    placeholder: 'Selecciona un color',
    label: 'Color exterior',
    errors: {
      empty: {
        text: 'Campo obligatorio'
      }
    }
  },
  price: {
    persists: true,
    type: 'input',
    inputType: 'number',
    placeholder: 'Introduce el precio',
    label: 'Precio',
    errors: {
      empty: {
        text: 'Campo obligatorio'
      },
      notAllowed: {
        character: {
          text: 'No introduzcas carácteres especiales',
          pattern: /[`~@#$^&¬|=<>{}[\]\\]/
        },
        phone: {
          text: 'No introduzcas números de teléfono',
          pattern: /[0-9]{9}/
        },
        mail: {
          text: 'No introduzcas direcciones de correo electrónico',
          pattern:
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        },
        url: {
          text: 'No introduzcas direcciones de navegación web',
          pattern: /http|www|ftp/
        }
      }
    }
  },
  comments: {
    persists: true,
    type: 'text-area',
    size: 'long',
    placeholder: 'Comentarios adicionales',
    label: '¿Quieres indicar algo más?',
    errors: {
      empty: {
        text: 'Campo obligatorio'
      },
      notAllowed: {
        character: {
          text: 'No introduzcas carácteres especiales',
          pattern: /[`~@#$^&¬|=<>{}[\]\\]/
        },
        phone: {
          text: 'No introduzcas números de teléfono',
          pattern: /[0-9]{9}/
        },
        mail: {
          text: 'No introduzcas direcciones de correo electrónico',
          pattern:
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        },
        url: {
          text: 'No introduzcas direcciones de navegación web',
          pattern: /http|www|ftp/
        }
      }
    }
  }
}
